export default __webpack_public_path__ + "static/media/aftm.a0ef7154.svg";